import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import ComboBoxRedux from "components/molecules/ComboBoxRedux";
import PrivilegeService from "utils/privilege.util";
import VehicleService from "services/vehicle.service";

export default function SelectSearchVehicle(props: any) {
	const vehicleOptions = useAppSelector((state) => state.vehicle.vehicleOptions);
	const permissions = useAppSelector((state) => state.auth?.user?.role_id?.permissions);


	useEffect(() => {
		if (PrivilegeService.checkPrivilege("vehicle:read", permissions)) {
			VehicleService.getAllVehicles({});
		}
	}, []);

	return <ComboBoxRedux {...props} options={vehicleOptions} />;
}
